import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useGetDomainRecognizationQuery } from "store/apis/serviceTeam";
import { BrandEntityCreateWrapper } from "signInSignUp/BrandEntityCreateWrapper";
import { useLocalStorage } from "hooks/useLocalStorage";
import {
  ONBOARDING_CURRENT_STEP_KEY,
  useUserOnboardingStepper,
} from "hooks/useUserOnboardingStepper";
import authContext from "jwt_context&axios/authContext";
import { BrandOption } from "./BrandOption";

export const OnBoardingAction = () => {
  const { data: groups = [] } = useGetDomainRecognizationQuery();
  const location = useLocation();
  const groupAvailable = groups?.length > 0;
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const { authtoken } = useContext(authContext) || {};
  const userIdentifier = authtoken?.uuid || currentUser?.uuid || "default";
  const { goBack, goNext } = useUserOnboardingStepper();

  const { localData: savedBrandName } = useLocalStorage(
    `onboarding_brand_${userIdentifier}`,
    ""
  );
  const currentStep = localStorage.getItem(ONBOARDING_CURRENT_STEP_KEY);
  const stepFromUrl = new URLSearchParams(location.search).get("step");

  // The user already picked "create a brand" and moved into the form — keep them
  // there on refresh instead of dropping them back on the join screen.
  const isBrandCreationInProgress =
    stepFromUrl === "brand" ||
    stepFromUrl === "entity" ||
    currentStep === "BRAND_CREATE" ||
    currentStep === "ENTITY_CREATE";

  const [isCreateBrand, setCreateBrand] = useState(
    !groupAvailable || isBrandCreationInProgress
  );

  const [isEntityCreate, setEntityCreate] = useState(
    Boolean(savedBrandName) && currentStep === "ENTITY_CREATE"
  );

  useEffect(() => {
    if (isBrandCreationInProgress) return;
    setCreateBrand(!groupAvailable);
  }, [groupAvailable, isBrandCreationInProgress]);

  return (
    <div className="t-h-full t-flex t-flex-col t-overflow-hidden sm:t-h-auto sm:t-overflow-visible">
      {isCreateBrand ? (
        <BrandEntityCreateWrapper
          isEntityCreate={isEntityCreate}
          setEntityCreate={setEntityCreate}
          moveBack={goBack}
          moveNext={goNext}
        />
      ) : (
        <BrandOption
          setCreateBrand={setCreateBrand}
          handleGoBack={() => setCreateBrand(true)}
        />
      )}
    </div>
  );
};
